export default "__VITE_ASSET__DAyB1JJ$__"